import { Routes } from "@angular/router";
import { ExtractsComponent } from "src/app/components/extracts/extracts.component";
import { InquiriesComponent } from "src/app/components/inquiries/inquiries.component";
import { MarketComponent } from "src/app/components/market/market.component";
import { MyChildComponent } from "src/app/components/my-child/my-child.component";
import { NotificationsComponent } from "src/app/components/notifications/notifications.component";
import { TermsAndConditionsComponent } from "../components/terms-and-conditions/terms-and-conditions.component";
import { termsAndConditionsGuard } from "../guards/terms-and-conditions.guard";
import { TermsAndConditionsToReadComponent } from "../components/terms-and-conditions/terms-and-conditions-to-read/terms-and-conditions-to-read.component";
import { ViewUserComponent } from "src/app/components/User/view-user/view-user.component";

export const content: Routes = [
  {
    path: "dashboard",
    loadChildren: () => import("../../components/dashboard/dashboard.module").then((m) => m.DashboardModule),
  },
  {
    path: "enrollment",
    loadChildren: () => import("../../components/enrollment-requests/enrollment-requests.module").then((m) => m.EnrollmentRequestsModule),
  },
  {
    path: "upgrade",
    loadChildren: () => import("../../components/upgrade-requests/upgrade-requests.module").then((m) => m.UpgradeRequestsModule),
  },
  {
    path: "withdrawal",
    loadChildren: () => import("../../components/withdrawal-requests/withdrawal-requests.module").then((m) => m.WithdrawalRequestsModule),
  },
  {
    path: "contact-us",
    loadChildren: () => import("../../components/contact-us/contact-us.module").then((m) => m.ContactUsModule),
  },
  {
    path: "notifications",
    loadChildren: () => import("../../components/notifications/notifications.module").then((m) => m.NotificationsModule),
  },
  {
    path: "child",
    loadChildren: () => import("../../components/my-child/my-child.module").then((m) => m.MyChildModule),
  },
  {
    path: "transportation",
    loadChildren: () => import("../../components/transportation/transportation.module").then((m) => m.TransportationModule),
  },
  {
    path: "transformation",
    loadChildren: () => import("../../components/transformation/transformation.module").then((m) => m.TransformationModule),
  },
  {
    path: "debts",
    loadChildren: () => import("../../components/debts/debts.module").then((m) => m.DebtsModule),
  },
  {
    path: "discounts",
    loadChildren: () => import("../../components/discount/discounts.module").then((m) => m.DiscountsModule),
  },
  {
    path: "CRM",
    loadChildren: () => import("../../components/CRM/CRM.module").then((m) => m.CRMModule),
  },
  {
    path: "suggestions",
    loadChildren: () => import("../../components/suggestions/suggestions.module").then((m) => m.SuggestionsModule),
  },
  {
    path: "questionnaires",
    loadChildren: () => import("../../components/questionnaires/questionnaires.module").then((m) => m.QuestionnairesModule),
  },
  {
    path: 'terms/terms-and-conditions',
    component: TermsAndConditionsToReadComponent
  },
  {
    path: 'market',
    component: MarketComponent
  },
  {
    path: 'inquiries',
    component: InquiriesComponent
  },
  {
    path: 'extracts',
    component: ExtractsComponent
  },
  {
    path: "user",
    loadChildren: () => import("../../components/User/user.module").then((m) => m.UserModule)
  },
  {
    path: "my-wallet",
    loadChildren: () => import("../../components/wallets/wallets.module").then((m) => m.WalletsModule)
  },
];
